export default __webpack_public_path__ + "static/media/cov-19-vacc-book.65ec2ec7.png";